import vconst from 'utils/helpers/structs/vconst';

type ExpendTeamLike = {
    income_status?: number | string;
    incomeCount?: number;
    income_count?: number;
    incomePriceSale?: number;
    income_price_sale?: number;
};

type ObjectCardDataLike = {
    expendTeams?: ExpendTeamLike[] | null;
};

type ObjectInfoLike = {
    prodPriceSale?: number;
} | null;

/**
 * Фактична вартість: списані товари + активні послуги й «Інше».
 * «Позапланове» сюди не входить: мінус — видаток об'єкта, плюс — додаткова дохідність.
 */
export const getActualObjectCost = (
    vObject: ObjectCardDataLike | null | undefined,
    vObjectInfo: ObjectInfoLike,
): number => {
    const productsSale = Number(vObjectInfo?.prodPriceSale) || 0;

    let servicesSale = 0;
    vObject?.expendTeams?.forEach((expend) => {
        if (Number(expend.income_status) !== vconst.incomeStatActive) return;
        const count = Number(expend.income_count ?? expend.incomeCount ?? 1) || 1;
        const priceSale = Number(expend.income_price_sale ?? expend.incomePriceSale ?? 0);
        servicesSale += count * priceSale;
    });

    return Math.round((productsSale + servicesSale) * 100) / 100;
};
